import router from "@/router/index";
import axios from "axios";
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  updateLocalAccessToken,
} from "@/utils/tokenService.js";

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token; // for back-end
      // config.headers["x-access-token"] = token; // for back-end
    }
    config.headers.Timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== "/login" && err.response) {
      // Access Token was expired+
      if (err.response.status === 401) {
        if (originalConfig.url == "/api/v1/token/refresh/") {
          localStorage.clear();
          if (router.currentRoute.fullPath.indexOf("/login") == -1) {
            router.push({
              name: "login",
            });
          }
        }

        try {
          const rs = await axiosInstance.post("/api/v1/token/refresh/", {
            refresh: getLocalRefreshToken(),
          });
          const { access } = rs.data.data;
          // store.dispatch("auth/refreshToken", accessToken);

          updateLocalAccessToken(access);

          return axiosInstance(originalConfig);
        } catch (_error) {
          return Promise.reject(_error);
        }
      } else if (err.response.status == 403) {
        localStorage.clear();
        if (router.currentRoute.fullPath.indexOf("/login") == -1) {
          router.push({
            name: "login",
          });
        }
      } else if (err.response.status == 404) {
        router.push({
          path: `${err.response.status}`,
        });
      }

      return Promise.reject(err);
    }
  }
);

export default axiosInstance;
